import * as Ajax from "../../pwa/ajax";
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";
import {sugerenciasPie} from "../../../Settings/global/nota.json";
import * as Cookie from '../common/cookie';

const sitioId = window.config.Sitio.Id;
const urlApiRoot = window.config.Statics.ApiContenidoUrlRoot;
const urlApiCategorias = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiCategoriasUrl;
const urlApiLogin = window.config.Statics.APILoginUrl;
const bucket = window.config.Statics.BucketUrl;
const urlApiNewsletter = urlApiLogin + window.config.Statics.ApiNewsletterSugerenciaUrl;
const urlApiSuscribirse =  urlApiLogin + window.config.Statics.ApiUrlSuscribirse;


const renderNotasPieCategoria = (data , categoriaRandom) => {
    const container = document.getElementById("bloque-4");
    if (!container || data == null) return;
    let heightBucket;
    let widthBucket;
    let conAutor;
    let categoria;
    let listado;
    for (let j = 0; j < categoriaRandom.length; j++) {
        if (data[categoriaRandom[j]].items.length > 0) {
            categoria = data[categoriaRandom[j]].items[0].categoriaDescripcion;
            listado = "<div>";
            const notas = data[categoriaRandom[j]].items.slice(0, 5);
            listado += `<h3>${categoria}</h3>`;
            for (let i = 0; i < notas.length; i++) {
                const nota = notas[i];
                const conImagen = nota.imagenes.length > 0 && nota.imagenes[0].src !== "";
                (i === 0) ? heightBucket = 183 : heightBucket = 80;
                (i === 0) ? widthBucket = 282 : widthBucket = 107;
                (nota.autores.length > 0 && nota.autores[0].hdImagenId !== null && nota.autores[0].valor !== "")
                    ? conAutor = "autor"
                    : conAutor = "";
                listado += `<article class="nota ${conAutor} floatFix">`;

                if (i === 0) {
                    listado += `<a class="figure" href="${nota.url}" "data-numero="${i}" data-tipo="normal-primera">`;
                    listado += conImagen
                        ? `<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket)}"/>`
                        : "";
                    listado += `</a>`;
                } else {
                    if (conAutor === "") { //conImagen && Si se lo saco qu eonda?
                        listado += `<a class="figure"  href="${nota.url}" data-numero="${i}" data-tipo="normal">`;
                        listado += conImagen
                            ? `<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, heightBucket)}"/>`
                            : "";
                        listado += `</a>`;
                    } else if (conAutor !== "") { // && nota.autores[0].hdImagenId !== 0 - Si se lo saco qu eonda?
                        listado += `<a class="figure"  href="${nota.url}" data-numero="${i}" data-tipo="autor">`;
                        listado += nota.autores[0].hdImagenId !== 0
                            ? `<img src="${BucketTools.urlBucketBalance(bucket,
                                nota.autores[0].hdImagenId,
                                heightBucket,
                                "",
                                nota.autores[0].hdImagenExtension)}"/>`
                            : "";
                        listado += `</a>`;
                    }
                }

                listado += `<h2><a href="${nota.url}">${nota.titulo}</a></h2>`;
                if (conAutor !== "") {
                    listado += `<a href="${Utilities.formatoUrlAcuAutor(nota.autores[0].valor, nota.autores[0].id)
                        }" class="autor">${nota.autores[0].valor}</a>`;
                }
                listado += `</article>`;
            }
            listado += "</div>";
            container.insertAdjacentHTML("afterbegin", listado);
        }
    }
}

const renderSugerenciaNewsletter = (data) => {
    let suscripcionPendiente = localStorage.getItem("suscripcionPendiente");
    let fechaSuscripcionPendiente = localStorage.getItem("fechaSuscripcionPendiente");
    let token = Cookie.LeerCookie("token");
    let tiempoCacheMilisegundos = 300000;///TODO:Cambiar a configuracion
    let dif = tiempoCacheMilisegundos;

    if (fechaSuscripcionPendiente !== null) {
        dif = Date.now() - fechaSuscripcionPendiente;
    }

    if (token !== "" && suscripcionPendiente !== null && dif < tiempoCacheMilisegundos) {
        let objPendiente = data.filter(p => p.servicioId === parseInt(suscripcionPendiente));
        if (objPendiente.length > 0) {
            let tituloPendiente = objPendiente[0].titulo;
            renderCajaSuscribir(tituloPendiente);
        }

        suscribirNewsletterAjax(data, token, suscripcionPendiente);
        localStorage.removeItem("suscripcionPendiente");
        localStorage.removeItem("fechaSuscripcionPendiente");


    } else if (data.length > 0) {
        if (suscripcionPendiente !== null) {
            localStorage.removeItem("suscripcionPendiente");
            localStorage.removeItem("fechaSuscripcionPendiente");
        }

        let sinSuscripcion = data.filter(d => d.suscripto === 0);
        if (sinSuscripcion.length === 0) {
            return;
        }

  
        let sugerenciasSuscripcion = [];
        for (let i = 0; sinSuscripcion.length > i; i++) {
            sugerenciasSuscripcion.push(sinSuscripcion[i].servicioId);
        }
        
        let newsRandom = Utilities.getRandom(sugerenciasSuscripcion, 1);

        let objSugerencia = newsRandom.length > 0
            ? data.filter(x => x.servicioId === newsRandom[0])
            : [];

        if (objSugerencia.length > 0) {
            let tituloSugerencia = objSugerencia[0].titulo;
            renderCajaSuscribir(tituloSugerencia);
        }

        let btn = document.getElementById("suscribirse");
        if (btn == null)
            return;
        if (token !== "") {
            btn.addEventListener("click", () => { suscribirNewsletterAjax(data, token, newsRandom) });
        } else {
            btn.addEventListener("click", () => { loguearYSuscribir(newsRandom); });

        }
    }
}


const renderCajaSuscribir = (tituloADibujar) => {
    let boton = document.createElement("BUTTON");
    let textoBoton = document.createTextNode("SUSCRIBIRME");
    boton.setAttribute("id", "suscribirse");
    boton.appendChild(textoBoton);

    const containerFinCuerpo = document.getElementsByClassName("fin-cuerpo")[0];
    const containerSegunda = document.getElementsByClassName("segunda floatFix")[0];

    const container = containerFinCuerpo !== undefined
                            ? containerFinCuerpo
                                : containerSegunda !== undefined
                                    ? containerSegunda
                                    : false;
    
    if (!container) return;
    let recomendacion = "<div class='titulares-del-dia'>";
    recomendacion += "<span class='icon-mail-line'></span>";
    recomendacion += `<div><b>${tituloADibujar}</b>`;
    recomendacion += "<p id='textSuscripcion'>Suscribite al newsletter</p>";
    recomendacion += "</div>";
    recomendacion += boton.outerHTML;
    recomendacion += "</div>";
    container.insertAdjacentHTML("beforeend", recomendacion);
}
const saveNewsletterLocalStorage = (data) => {
    localStorage.setItem("fechaSugerenciaTitulares", Date.now().toString());
    localStorage.setItem("sugerenciasTitulares", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
}
const saveNewsletterLocalStorageDefault = (data) => {
    localStorage.setItem("sugerenciasTitularesDefault", JSON.stringify(data));
    renderSugerenciaNewsletter(data);
}

export const getSugerenciasPie = () => {
    let data = sugerenciasPie;
    let categoriaRandom = Utilities.getRandom(data[0].categoriasPosibles, data[0].cantidad);
    let categoriaString =  categoriaRandom.join() + "?c=5";

    Ajax.get(urlApiCategorias + categoriaString)
        .then((rs) => renderNotasPieCategoria(JSON.parse(rs), categoriaRandom));

}

export const getNewsletter = () => {
    const fechaSugerencia = localStorage.getItem("fechaSugerenciaTitulares"),
        sugerenciasData = JSON.parse(localStorage.getItem("sugerenciasTitulares")),
        tokenStorage = localStorage.getItem("token"),
        sugerenciaDataDefault = JSON.parse(localStorage.getItem("sugerenciasTitularesDefault"));
    let tiempoCacheMilisegundos = 300000; ///TODO:Cambiar a configuracion
    let dif = 0;

    if (tokenStorage != null) {
        //se fija que el localstorage tenga datos y el token coincida con el guardado
        if (fechaSugerencia != null && sugerenciasData != null) {
            dif = Date.now() - fechaSugerencia;
            //se fija que no haya vencido el cache
            if (dif < tiempoCacheMilisegundos) {
                renderSugerenciaNewsletter(sugerenciasData);
            } else {
                //vencio el cache entonces va a buscar de nuevo la data actualiza el localstorage y renderea
                obtenerSuscripciones(tokenStorage);
            }
        } else {
            obtenerSuscripciones(tokenStorage);
        }
    } else {
        //Si no esta logueado, se fija que tenga informacion en el LocalStorage
        if (sugerenciaDataDefault != null) {
            // dibuja con la data ya existente
            renderSugerenciaNewsletter(sugerenciaDataDefault);
        } else {
            obtenerSuscripciones("default");
        }
    }
}

const obtenerSuscripciones = (tipo) => {
        if (tipo === "default") {
            Ajax.post(urlApiNewsletter)
                .then(rs => JSON.parse(rs))
                .then(saveNewsletterLocalStorageDefault);
        } else {
            let objHeaders = {
                "X-Token": tipo
            }
            Ajax.post(urlApiNewsletter + "PorUsuario","", objHeaders )
                .then(rs => JSON.parse(rs))
                .then(saveNewsletterLocalStorage);
        }

    }

const suscribirNewsletterAjax = (data, token , suscribirse) => {
        let serviciosYaSuscripto = data.filter(s => s.suscripto === 1); 
        let urlSuscribirse = urlApiSuscribirse;
        let stringIds = "";
        if (serviciosYaSuscripto.length > 0) {
            for (let k = 0; serviciosYaSuscripto.length > k; k++) {
                stringIds += serviciosYaSuscripto[k].servicioId + ",";
            }
        }
        stringIds += suscribirse;
        let objParam = {
            "servicios_ids": stringIds,
            "acepta_novedades":null
        }
        let objHeaders = {
            "Content-Type":"application/json",
            "X-Token": token
    }

        suscribirNewsletterLogueado(urlSuscribirse, objParam ,objHeaders);
}

const suscribirNewsletterLogueado = (url ,objParam , objHeaders) => {
    document.getElementById( "suscribirse" ).style.display = "none";
    Ajax.post(urlApiSuscribirse , objParam , objHeaders).then(suscripcionCorrecta).catch(suscripcionError);
    localStorage.removeItem("sugerenciasTitulares");
}

const loguearYSuscribir = (newsRandom) => {
    document.getElementById( "suscribirse" ).style.display = "none";
    localStorage.setItem("tareaPendiente", newsRandom);
    localStorage.setItem("fechaPendiente", Date.now().toString());
    localStorage.removeItem("sugerenciasTitulares");
    location.href = window.config.Statics.LoginUrl + window.btoa(location.href);
}

const suscripcionCorrecta = (mensaje) => {
    document.getElementById("textSuscripcion").innerText = "¡Ya estás suscripto!";
    localStorage.removeItem("tareaPendiente");
    localStorage.removeItem("fechaPendiente");
}

const suscripcionError = () => {
    document.getElementById("textSuscripcion").innerText = "¡Ups volvé a intentarlo!";
    document.getElementById( "suscribirse" ).style.display = "block";

}
    




// WEBPACK FOOTER //
// ./Statics/scripts/nota/sugerencias.js